import { css } from '@emotion/css';

export const getStyles = () => ({
  panel: css`
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
  `,
});
